import React, {useEffect, useState} from 'react'
import {isMobile} from '../util'
import MobileLink from './MobileLink/MobileLink'
import {WEB_BASE} from './util'

const Open = ({match}) => {
    const {projectionId, personId} = match.params
    const [showMobileLink, setShowMobileLink] = useState(false)

    useEffect(() => {
        if (isMobile) {
            setShowMobileLink(true)
        } else {
            window.location = `${WEB_BASE}/${projectionId}/profile/${personId}`
        }
    })

    if (showMobileLink) {
        return <MobileLink link={`namesandfaces://profile/${projectionId}/${personId}`} />
    } else {
        return '...'
    }
}

export default Open
